import React from 'react';

const SelectedStarbeatProductCard = ({ productDetailData }) => {
  return (
    <div className='selected-product-card type-starbeat-card'>
      <div className='selected-product-bottom-group'>
        <div className='starbeat-quantity-group'>
          <span className='starbeat-quantity-icon-group'>
            <i className='icon icon-star-point' />
          </span>
          <span className='starbeat-quantity-info'>{productDetailData.name}</span>
        </div>
        <p className='price-group'>
          {/* 가격 */}
          {productDetailData.price?.toLocaleString()}
          {/* 통화 표기 */}
          <>&nbsp;{productDetailData.currency}</>
        </p>
      </div>
    </div>
  );
};

export default SelectedStarbeatProductCard;
